import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { NAV, SERVICES, SITE } from "@/data/site";
import { LogoFull } from "@/components/layout/Logo";

const Col = ({ title, children }) => (
  <div>
    <p className="eyebrow mb-5 text-slate-400">{title}</p>
    <ul className="space-y-3 text-[14px]">{children}</ul>
  </div>
);

const fLink = "text-slate-300 transition-colors duration-200 hover:text-white";

export const Footer = () => (
  <footer className="relative overflow-hidden bg-[#030712] text-slate-300" data-testid="site-footer">
    <div className="grad-line h-px w-full opacity-60" />
    <div className="container-q grid gap-12 py-16 lg:grid-cols-12 lg:py-20">
      <div className="lg:col-span-4">
        <LogoFull variant="dark" className="-ml-3 h-auto w-[210px]" />
        <p className="mt-6 max-w-sm text-[14px] leading-relaxed text-slate-400">
          Quantivo is a software development and technology solutions company based in Kolkata, India, building SaaS products, custom software, automation and API-driven platforms for businesses in India and abroad.
        </p>
      </div>
      <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-8">
        <Col title="Company">
          {NAV.map((n) => (
            <li key={n.to}><Link to={n.to} className={fLink} data-testid={`footer-link-${n.label.toLowerCase()}`}>{n.label}</Link></li>
          ))}
        </Col>
        <Col title="Services">
          {SERVICES.map((s) => (
            <li key={s.slug}><Link to={`/services/${s.slug}`} className={fLink} data-testid={`footer-service-${s.key}`}>{s.label}</Link></li>
          ))}
        </Col>
        <Col title="Contact">
          <li><a href={`mailto:${SITE.email}`} className={`${fLink} inline-flex items-start gap-2 break-all`} data-testid="footer-email"><Mail className="mt-0.5 h-4 w-4 shrink-0" />{SITE.email}</a></li>
          <li><a href={SITE.phoneHref} className={`${fLink} inline-flex items-center gap-2`} data-testid="footer-phone"><Phone className="h-4 w-4" />{SITE.phone}</a></li>
          <li><a href={SITE.whatsapp} target="_blank" rel="noopener noreferrer" className={`${fLink} inline-flex items-center gap-2`} data-testid="footer-whatsapp"><MessageCircle className="h-4 w-4" />WhatsApp</a></li>
          <li className="inline-flex items-start gap-2 text-slate-400"><MapPin className="mt-0.5 h-4 w-4 shrink-0" />{SITE.location}</li>
        </Col>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-q flex flex-col gap-4 py-6 text-[13px] text-slate-400 sm:flex-row sm:items-center sm:justify-between">
        <p>© {new Date().getFullYear()} Quantivo. <span className="font-mono text-slate-400">Innovate. Automate. Scale.</span></p>
        <div className="flex gap-6">
          <Link to="/privacy" className={fLink} data-testid="footer-privacy">Privacy Policy</Link>
          <Link to="/terms" className={fLink} data-testid="footer-terms">Terms of Service</Link>
        </div>
      </div>
    </div>
  </footer>
);
